import { render } from "./cases.vue?vue&type=template&id=66b9d77a"
import script from "./cases.vue?vue&type=script&lang=js"
export * from "./cases.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__